export default __webpack_public_path__ + "static/media/favourite-filled.4442b7b2.svg";